if (!String.prototype.at) {
  String.prototype.at = function (index) {
    index = Math.trunc(index) || 0;
    if (index < 0) index += this.length;
    if (index < 0 || index >= this.length) return '';
    return this.charAt(index);
  };
}
